<template lang="">
  <div class="mypage_head">
    <div class="tit">마이페이지</div>
    <div class="welcome">
      <h5>welcome</h5>
      <p><span>{{ userInfo.name }}</span>님 환영합니다.</p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';


const accountModule = 'accountModule'

export default {
  computed: {
    ...mapState(accountModule, ['userInfo'])
  }
}
</script>
<style lang="">
  
</style>